import { EGetCustomerNameByInnStatus, IGetCustomerNameByInnMappers } from './types';

export const mappers: IGetCustomerNameByInnMappers = {
  200: state => ({
    name: state.name,
    message: null,
    status: EGetCustomerNameByInnStatus.Success,
  }),
  400: ({ message }) => ({
    name: null,
    message,
    status: EGetCustomerNameByInnStatus.Error,
  }),
};
